import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import {Task, TaskService} from '@app/_components/task';

@Component({
    selector: 'app-task',
    templateUrl: './quick-task.component.html',
    styleUrls: ['./quick-task.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class QuickTaskComponent implements OnInit {

	constructor(
		private primengConfig: PrimeNGConfig,
		private taskService: TaskService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		private dialogRef: MatDialogRef<QuickTaskComponent>,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.task = data.task,
			this.statuses = taskService.statuses;
	}

	@Input() task: Task;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();
  assignedToUser: any;
  assignedToTeam: any;
	// data
	taskId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'taskId': [],
		'name': [
			{ type: 'required', message: 'Required' },
			{ type: 'minlength', message: '5 characters minimum' }],
		'description': [
			{ type: 'required', message: 'Required' }
		],
		'assignedTo': [],
		'assignedToTeam': [],
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole task object
		if (this.task) {
			this.taskId = this.task.taskId;
			this.form1.patchValue(this.task);
		}
	}


	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}


      this.form1.value.assignedToUserId = this.assignedToUser ? this.assignedToUser.userId : null;
      this.form1.value.assignedToTeamId = this.assignedToTeam ? this.assignedToTeam.teamId : null;
      this.form1.value.team = this.assignedToTeam || null;
      this.form1.value.assignedTo = this.assignedToUser || null;
      this.form1.value.priority = 4;
      this.form1.value.status = 2;
      if (this.form1.value.dateToFollowup) {
        this.form1.value.dateToFollowup = moment(this.form1.value.dateToFollowup).format('YYYY-MM-DD');
      }
      if (this.form1.value.dateDue) {
        this.form1.value.dateDue = moment(this.form1.value.dateDue).format('YYYY-MM-DD');
      }
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.taskService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.task = res.data ? res.data.task : null;
						this.doAdd.emit(this.task);
						// Close the dialog with the saved task (or true as a truthy sentinel when
						// the task object is absent). afterClosed() in the parent uses this value
						// to distinguish a successful save from a Cancel/X dismissal.
						this.dialogRef.close(this.task || true);
					},
					(err: any) => {
						console.log('task-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('task: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.taskService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.task = res.data.task;
						this.doUpdate.emit(this.task);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.taskService.delete(this.task.taskId)
				.subscribe(
					(res: any) => {
						console.log('task-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.task);
					},
					(err: any) => {
						console.log('task-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
    const now = new Date();
    const currentDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 3);
		this.form1 = this.formBuilder.group({
			taskId: [this.taskId],
			name: ['', Validators.compose(
				[
					Validators.minLength(5),
					Validators.required
				])],
			description: [],
      dateDue: [currentDate],
      dateToFollowup: [currentDate],
      assignedToUserId: [],
      assignedToTeamId: [],
		});
	}

  onAssignedToUserSeleted(user: any) {
    this.assignedToUser = user;
  }
  onAssignedToTeamSeleted(team: any) {
    this.assignedToTeam = team;
  }
}
